import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
// baseUrl
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Index() {
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!startTime.trim()) {
      toast.error("Subject name cannot be empty");
      //   alert("Please enter class name");
      return;
    }
    console.log("New Subject Added:", startTime, endTime);
    setStartTime(""); // reset input
    setEndTime("");

    axios
      .post(`${baseURL}/slots`, { startTime, endTime })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data?.message || "lots added successfully");
        // alert("Class added successfully");
        //  navigate("/curriculum");
      })
      .catch((error) => {
        console.error("Error adding class:", error);
        toast.error(error.response?.data?.message);
        // alert("Failed to add class");
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card sx={{ p: 3, borderRadius: "16px", boxShadow: 3 }}>
            <ArgonTypography mb={1} variant="h5" fontWeight="bold">
              Add Timeslot
            </ArgonTypography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <ArgonBox display="flex" alignItems="center" gap={2}>
                {/* Input Field */}
                <ArgonBox display="flex" gap={2}>
                  <ArgonInput
                    type="time"
                    placeholder="Enter Start Time"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    sx={{ width: "50%" }}
                  />
                  <ArgonInput
                    type="time"
                    placeholder="Enter End Time"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    sx={{ width: "50%" }}
                  />
                </ArgonBox>
                {/* Button */}
                <ArgonButton
                  color="primary"
                  type="submit"
                  variant="contained"
                  size="small"
                  // sx={{ minWidth: "150px", height: "100%" }}
                >
                  Add Time
                </ArgonButton>
              </ArgonBox>
            </form>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Index;
